export const documentStudentExportColumn = `
    s.Stdid AS 'Student Id', im.Intakename AS 'Intake', lo.locname AS 'Branch', s.PaymentStatus AS 'Payment Status',
    ct.CatName AS 'Category', s.packageCode AS 'Package', 
    CASE WHEN s.ststatus = 0 THEN 'Active' 
        WHEN s.ststatus = 1 THEN 'HOLD' 
        WHEN s.ststatus = 2 THEN 'DROP' 
        WHEN s.ststatus = 3 THEN 'Alumni' 
        WHEN s.ststatus = 4 THEN 'InActive' 
        WHEN s.ststatus = 5 THEN 'Admission Deffered' 
        WHEN s.ststatus = 6 THEN 'Deffered Active' 
        WHEN s.ststatus = 7 THEN 'Ref/VIP' 
        ELSE 'Unknown' 
    END AS Status, 
    d.docname AS 'Document Name', sd.filename AS 'File Name', sd.AppvDate AS 'Approval Date', 
    sd.Appvuser AS 'Approved By', sd.AddDate AS 'Add Date',
    sd.status, d.mandatory AS 'Mandatory'
`